export const HOMEPAGE_DEFAULT_CATEGORY = [
  "all",
  "Advancing Independence",
  "Artists Like You",
  "Learn More",
];

export const SELECTED_OPTIONS = [
  {
    value: "all",
    label: "All",
  },
  {
    value: "tag",
    label: "Tag",
  },
  {
    value: "title",
    label: "Title",
  },
];
